import {
  TrackClassPageImpressionInput,
  TrackClassPageImpressionMutation,
  TrackClassPageImpressionMutationVariables,
} from "@outschool/gql-frontend-generated";
import { usePageContext } from "@outschool/ui-analytics";
import { gql, useMutation } from "@outschool/ui-apollo";
import React from "react";

const trackClassPageImpressionMutation = gql`
  mutation TrackClassPageImpression($input: TrackClassPageImpressionInput!) {
    trackClassPageImpression(input: $input)
  }
`;

export default function useTrackClassPageImpression() {
  const lastFiredPageImpressionId = React.useRef<string | null>(null);
  const pageContext = usePageContext();
  const [track] = useMutation<
    TrackClassPageImpressionMutation,
    TrackClassPageImpressionMutationVariables
  >(trackClassPageImpressionMutation);
  return React.useCallback(
    async (input: TrackClassPageImpressionInput) => {
      // Make sure that pageImpressionId exists before firing off track call
      if (
        !!pageContext.pageImpressionId &&
        pageContext.pageImpressionId !== lastFiredPageImpressionId.current
      ) {
        lastFiredPageImpressionId.current = pageContext.pageImpressionId;
        await track({
          variables: { input },
        });
      }
    },
    [track, pageContext.pageImpressionId]
  );
}
